/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import HollowInfoIcon from '@atlaskit/icon/core/information-circle';
import InfoIcon from '@atlaskit/icon/core/migration/status-information--info';
import { Anchor, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from '../messages';

import { CustomDisclaimer, type CustomDisclaimerProps } from './CustomDisclaimer';

const linkStyles = cssMap({
	default: {
		font: token('font.body.small'),
		color: token('color.text.subtle'),
		'&:visited': {
			color: token('color.text.subtle'),
		},
	},
});

export interface FooterDisclaimerProps {
	/** The appearance of main footer. */
	appearance: 'small' | 'medium' | 'large';
	/**
	 * Custom disclaimer to be displayed in the footer.
	 *
	 */
	disclaimer: CustomDisclaimerProps['disclaimer'] | undefined;
	isAIFC?: boolean;
}

export function FooterDisclaimer({ disclaimer, appearance, isAIFC }: FooterDisclaimerProps) {
	const { formatMessage } = useIntl();

	return disclaimer ? (
		<CustomDisclaimer disclaimer={disclaimer} />
	) : (
		<Inline space="space.050" alignBlock="center">
			{isAIFC ? (
				<HollowInfoIcon
					label={formatMessage(messages.infoIconLabel)}
					color={token('color.text.subtle')}
					LEGACY_size="small"
					size="small"
				/>
			) : (
				<InfoIcon
					label={formatMessage(messages.infoIconLabel)}
					color={token('color.text.subtle')}
					LEGACY_size="small"
					size="small"
				/>
			)}

			<Anchor
				color={token('color.text.subtle')}
				href="https://www.atlassian.com/trust/atlassian-intelligence"
				xcss={linkStyles.default}
			>
				{formatMessage(messages.disclaimerTextUpdated)}
			</Anchor>
		</Inline>
	);
}
